<script lang="ts" context="module">
	declare const jQuery: any;
</script>

<script lang="ts">
	import '$lib/css/master.css';
	import '$lib/css/responsive.css';

	import { page } from '$app/stores';
	import { onMount } from 'svelte';
	import { init } from '$lib/theme';
	import smoothscrollInit from '$lib/smoothscroll';
	import Footer from '$lib/components/Footer.svelte';
	import Navbar from '$lib/components/Navbar.svelte';
	import ViewportActionButtons from '$lib/components/ViewportActionButtons.svelte';
	import type { LayoutData } from './$types';
	import { SITE_DOMAIN } from '$lib/constants';

	export let data: LayoutData;
	let { pagePath } = data;
	$: ({ pagePath } = data);

	let loaded = false;

	onMount(async () => {
		// Legacy theme init
		jQuery(init);
		smoothscrollInit();
		loaded = true;
	});
</script>

<svelte:head>
	<link rel="canonical" href="https://{SITE_DOMAIN}{$page.url.pathname}" />
</svelte:head>

<main>
	<!--=== Wrapper Start ===-->
	{#if loaded}
		<div class="wrapper">
			<!--=== Header Start ===-->
			<Navbar />

			<!--=== Header End ===-->
			<slot />
			<!--=== Footer Start ===-->
			<Footer />
			<!--=== Footer End ===-->
		</div>
		<!--=== Wrapper End ===-->
		{#if data.pagePath !== '/contact'}
			<ViewportActionButtons />
		{/if}
	{/if}
</main>

<style global lang="scss">
	body {
		background-color: #212121;
	}

	.stopFouc {
		display: none;
	}

	.lead {
		font-weight: 400;
	}
</style>
